import Vue from 'vue'
import Vuex from 'vuex'
import user from './store/modules/user'
import competition from './store/modules/competition'
import facilities from './store/modules/facilities'

import { Api } from '@/core/api.js'
const api = new Api()

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    language: 'es',
    languages: [
      { name: 'en', selected: false },
      { name: 'es', selected: true },
      { name: 'ca', selected: false }
    ],
    title: 'MICLive',
    is_loading: false,
    refresh_time: 60 * 1000,
    sponsors: {},
    links: {}
  },
  modules: {
    user,
    competition,
    facilities
  },
  strict: debug,
  mutations: {
    setSponsors (state, value) {
      state.sponsors = value
    },
    setLinks (state, value) {
      state.links = value
    },
    setTitle (state, value) {
      state.title = value
    },

    setLoading (state, value) {
      state.is_loading = value
    },

    setLanguage (state, value) {
      for (var k in this.languages) {
        if (this.languages[k].name == value) this.languages[k].selected = true
        else this.languages[k].selected = false
      }
      state.language = value
    }
  },
  actions: {
    loadUser ({ commit, dispatch }) {
      return true
      //   return api.getSession().then(function(data) {
      //     if (data.status) {
      //       return commit("user/setAuthenticate", data.data);
      //     } else if (data.error == 403) {
      //       commit("user/logoutUser");
      //       return commit("user/setAuthenticate", false);
      //     }
      //   });
    },

    init ({ commit }) {
      api.initSession().then(function (response) {
        if (response.status) {
          localStorage.setItem('token', response.data)
          return true
        }
      })
    },

    logout ({ commit }) {
      commit('user/logoutUser')
    }
  },
  getters: {
    getLanguages: (state, getter, rootState) => {
      return state.languages
    },
    getSponsors: (state, getter, rootState) => (id) => {
      if (typeof state.sponsors[ id ] !== 'undefined') return state.sponsors[ id ]
      return false
    },
    getLinks: (state, getter, rootState) => {
      return state.links
    },
    getRefreshTime: (state, getter, rootState) => {
      return state.refresh_time
    }
  }
})
